<app-adminav></app-adminav>
<div class="container-fluid mt-5" style="max-width: 93%;">
    <div class="col-lg-12">
        <h3>Pedidos</h3>
        <hr>
        <h5>Filtrar Por:</h5>
        <div class="col-lg-12">
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group">
                        <label>Estado:</label>
                        <select class="form-control" (change)="filterByState($event.target.value)">
                          <option value="" selected>Seleccione:</option>
                            <option value="todos">Todos</option>
                            <option value="Aprobada">Aprobada</option>
                            <option value="Pendiente">Pendiente</option>
                            <option value="Rechazada">Rechazada</option>
                            <option value="Despachado">Despachado</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-6">
                    <label for="referencia">Referencia:</label>
                    <input class="form-control" (change)="filterByRef($event.target.value)" type="text" placeholder="Ingrese referencia" name="referencia" autocomplete="off">
                </div>
            </div>
        </div>
        <hr>
        <table class="table">
            <thead class="thead-dark">
                <tr>
                    <th scope="col">Fecha</th>
                    <th scope="col">Medio</th>
                    <th scope="col">Ref. pago</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Flete</th>
                    <th scope="col">Precio</th>
                    <th scope="col">acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of lista">
                    <td>{{item.fecha | date}}</td>
                    <td>{{item.pago}}</td>
                    <td>{{item.refCompra}}</td>
                    <td>{{item.estado}}</td>
                    <td>${{item.flete | number}}</td>
                    <td>${{item.total | number}}</td>
                    <td class="text-center">
                      <button *ngIf="item.estado == 'Aprobada'" type="button" (click)="enviarpedido(item.id)" class="btn btn-primary mr-1" title="Enviar Pedido">
                        <i class="fa fa-check fa-lg" aria-hidden="true"></i>
                      </button>
                        <button *ngIf="item.estado != 'Rechazada'" type="button" (click)="detailRequest(item)" class="btn btn-success mr-1" title="Ver detalle" data-toggle="modal" data-target="#staticBackdrop">
                            <i class="fa fa-list fa-lg" aria-hidden="true"></i>
                          </button>
                        <button *ngIf="item.estado == 'Pendiente'" type="button" class="btn btn-info mr-1" (click)="approve(item.id, item.compras)"  data-toggle="modal" data-target="#actInventario" title="Aprobar venta">
                            <i class="fa fa-check-square-o fa-lg" aria-hidden="true"></i>
                          </button>
                        <button *ngIf="item.estado != 'Aprobada'" type="button" class="btn btn-danger" (click)="deny(item.id)" title="Eliminar de la lista">
                            <i class="fa fa-ban fa-lg" aria-hidden="true"></i>
                          </button>
                        <button class="btn btn-success ml-1" (click)="whatsappcliente(item.cliente.telefono)"><i class="fa fa-whatsapp fa-lg" aria-hidden="true"></i></button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<div *ngIf="cliente && carrito" class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">Detalle de venta</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body" style="background-color: #fff;">
                <h4>Usuario:</h4>
                <p><small>Nombre: <b>{{cliente.nombre}}</b></small></p>
                <p><small>Documento: <b>{{cliente.tipodocumento}}</b></small> - <small>No. {{cliente.numero}}</small></p>
                <p><small>Direccion de entrega: <b>{{cliente.direccion}}</b></small></p>
                <p><small>Departamento: <b>{{cliente.departamento | titlecase}}</b></small></p>
                <p><small>Ciudad: <b>{{cliente.ciudad | titlecase}}</b></small></p>
                <p><small>Teléfono: <b>{{cliente.telefono}}</b></small></p>
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">Producto</th>
                            <th scope="col"></th>
                            <th scope="col">Cantidad</th>
                            <th scope="col">Precio</th>
                            <th scope="col">Descuento</th>
                            <th scope="col">Subtotal</th>
                            <th scope="col">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let producto of carrito">
                            <td><img [src]="producto.imagenProd" class="img-fluid" alt="" width="60"></td>
                            <td>
                                <h5>{{producto.nombreprod | titlecase}}</h5>
                            </td>
                            <td>{{producto.cantidad}}</td>
                            <td>${{producto.precio | number}}</td>
                            <td>%{{producto.descuento}}</td>
                            <td>${{producto.subtotal | number}}</td>
                            <td>${{producto.total | number}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
        </div>
    </div>
</div>
 
  <!-- Modal -->
  <div class="modal fade" id="actInventario" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Aceptar Pedido</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="background-color: #fff !important;">
         <div class="text-center">
            <h4>¡Se va a aprobar esta venta!</h4>
            <h5>¿Está seguro?</h5>
         </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          <button type="button" class="btn btn-primary" (click)="aprovarVenta()" data-dismiss="modal">Aprobar Venta</button>
        </div>
      </div>
    </div>
  </div>
